// Datepicker de plage de la searchbar hotel (desktop) — chargé uniquement par
// booking-searchbar.blade.php ; expose Litepicker pour le script inline du partial.
import Litepicker from 'litepicker';

window.Litepicker = Litepicker;
